// created by COGBEE
import React, { useEffect, useState } from 'react';
import RichTextEditor, { ToolbarConfig } from 'react-rte';
import { Input, Slider, Flex } from '@fluentui/react-northstar'

import { PrimaryButton, TextField, ActionButton } from '@fluentui/react';
import {
    copyLinkButtonStyle,
    rejectButtonStyle,
    noShowButtonStyle,
    RatingButtonStyle,
    selectLinkButtonStyle
} from './styles/CommandPanel.styles';
import { InterviewerDataModel, ParticipantInfo, Ratings, uriCode, UpdateRatings, UpdateRemark, UpdateStatus, CheckNullEmptyUndefined, ParticipantModel } from 'Utils/participantInfo';
import { SaveRatings, UpdateCandidateStatus, SaveRemarks, varRemarks } from 'Utils/interviewcomplete';
import { Typography } from '@mui/material';
import CustomPopup from './CustomPopup';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'

const MODERATE_RED = '#ff0000';
const YELLOW = '#A9a9a9';
const BLUE = 'rgb(12, 68, 172)';
const GREEN = '#32cd32';
const DARK_GREY = '#d3d3d3';
const SELECTED = 'Selected';
const REJECTED = 'Rejected';
const NOSHOW = 'No-Show';

let dButton = true;
dButton = false;


const SaveRating = (ratingId: number, txtId: string): void => {

    SaveRatings(uriCode, ratingId, txtId);
    let inputs = document.getElementById(txtId) as HTMLInputElement;
    inputs = document.getElementById(txtId) as HTMLInputElement;
    //for (var i = 0; i < inputs.length; i++) {

    let rateScore = parseFloat(inputs.value);
    rateScore = parseFloat(inputs.value);
    UpdateRatings(ratingId, isNaN(rateScore) ? 0 : rateScore);
};

const modelone: ParticipantInfo = InterviewerDataModel();
let ratingList: Ratings[];

if (modelone != undefined) {
    ratingList = modelone.ratingsList as Ratings[];
}

let remarkList: { ratingID: number, remark: string }[] = [];
remarkList.push({ ratingID: 0, remark: "" });
remarkList = [];

const RatingValidation = (id: number, event: any): void => {
    if (isNaN(event)) {
        const txtValue = document.getElementById(`ratingTxtInput_${id}`) as HTMLInputElement;
        txtValue.style.borderColor = "#ff0000";
    }
}


const App1 = (isMobile: boolean, browserName: string | undefined): JSX.Element[] => {
    const modelone: ParticipantInfo = InterviewerDataModel();

    const stateReducer = (state: any, action: any) => {
        switch (action.type) {
            case 'change_value':
                if (action != null && action != undefined) {
                    let val = parseFloat(action.value);
                    val = parseFloat(action.value);
                    val = isNaN(val) ? 0 : val;
                    if (val > 10) {
                        val = 10;
                    }
                    if (val < 1 && val != 0) {
                        val = 1;
                    }
                    if (val - Math.floor(val) != 0.5) {
                        val = Math.round(val);
                    }
                    const stateval = parseFloat(state.value);
                    if (stateval > 0) {
                        state.value = isNaN(stateval) ? "" : stateval;
                    }
                    UpdateRatings(action.itemID as number, val);
                    return {
                        ...state,
                        value: val,
                        name: action.name
                    }
                }
            default:
                throw new Error(`Action ${action.type} is not supported`)
        }
    }

    const { min, max, step } = {
        min: 1,
        max: 10,
        step: 0.5,
    }

    const [state1, dispatch] = React.useReducer(stateReducer, {
        value: min + (max - min) / 2,
        currentValue: min,
        minValue: min
    })

    const handleChange = React.useCallback(
        (e, data) =>
            dispatch({
                type: 'change_value',
                value: data.value as number,
                name: e.target.name,
                itemID: data.itemID
            }),
        [],
    )

    const commonProps = {
        min,
        max,
        onChange: handleChange,
        step,
        names: state1.value,
        name: state1.name,
        value: state1.value
    }


    if (modelone != undefined && modelone.role == "Interviewer") {
        const ratingList = modelone.ratingsList as Ratings[];
        if (CheckNullEmptyUndefined(ratingList)) {
            const App2 = ratingList.map((ratings) => (
                <div key={`rating_${ratings.id}-tile`} style={{ padding: "5px" }} >
                    <label title={ratings.label}>{isMobile ? '' : ratings.label}</label>
                    <span
                        style={{
                            fontSize: "20px",
                            color: "red"
                        }}
                    >{isMobile ? '' : '*'}</span>
                    {isMobile ? <></> : (<span style={{ fontWeight: 400 }}>({ratings.weight})</span>)}

                    <div style={{ display: "inline-flex", width: "100%" }}>

                        <p
                            title={ratings.label}
                            style={{
                                width: isMobile ? '53%' : '',
                                alignSelf: 'center', fontSize: isMobile && browserName == "safari" ? '16px' : '14px',
                                fontWeight: "bold"
                            }} >{isMobile ? ratings.label : ''}
                            <span
                                style={{
                                    fontSize: "20px",
                                    color: "red",
                                    position: "relative",
                                    left: "2px"
                                }}
                            >{isMobile ? '*' : ''}</span>
                            {isMobile ? (<span style={{ fontWeight: 400, marginLeft: "5px" }}>({ratings.weight})</span>) : <></>}
                        </p>

                        <Slider
                            {...commonProps}
                            value={commonProps.name == ratings.label ? commonProps.names : ratings.score}
                            name={ratings.label}
                            vertical={false}
                            style={{ width: "80%", alignSelf: "center", display: isMobile ? 'none' : 'block' }}
                            id={`ratingTxt_${ratings.id}`}
                            itemID={ratings.id.toString()}
                            onClick={(event) => { SaveRating(ratings.id, `ratingTxt_${ratings.id}`) }}
                        />
                        <div
                            style={{ width: isMobile ? '45%' : "35%", display: "flex", justifyContent: "end" }}
                        >
                            <Input
                                className="fluat-input-style"
                                type="number"
                                {...commonProps}
                                name={ratings.label}
                                value={commonProps.name == ratings.label ? commonProps.names : ratings.score}
                                id={`ratingTxtInput_${ratings.id}`}
                                style={{ width: isMobile ? '31%' : '21%', fontSize: isMobile && browserName == "safari" ? '16px' : '14px' }}
                                itemID={ratings.id.toString()}
                                onKeyUp={(event) => { SaveRating(ratings.id, `ratingTxtInput_${ratings.id}`) }}
                                onBlur={(event) => { RatingValidation(ratings.id, event.target.value) }}
                            />
                            <TextField
                                autoComplete="off"
                                borderless={true}
                                id={`ratingTxtDefault_${ratings.id}`}
                                placeholder="Score"
                                defaultValue={`/ 10`}
                                style={{ width: '45px', backgroundColor: '#f3f2f1', marginLeft: '0px', fontSize: isMobile && browserName == "safari" ? '16px' : '14px' }}
                                readOnly={true}
                            />
                        </div>
                    </div>
                    <textarea
                        className="form-control clstext ratingtxtarea"
                        id={"txtArea_" + ratings.id}
                        rows={2}
                        defaultValue={ratings.remark}
                        style={{ width: isMobile ? '90%' : '96%', fontSize: isMobile && browserName == "safari" ? '16px' : '14px' }}
                        onChange={(event) => { UpdateRemark(ratings.id, event.target.value) }}
                    />
                </div>
            ));
            return App2;
        } else {
            const App2: any = (<div id="hhk" style={{ display: 'none' }}><div></div></div>);
            return App2;
        }
    }
    else {
        const App2: any = (<div id="hhk" style={{ display: 'none' }}><div></div></div>);
        return App2;
    }
}



export default (): JSX.Element => {
    const modelone: ParticipantInfo = ParticipantModel();
    if (ratingList == undefined) {
        ratingList = modelone.ratingsList as Ratings[];
    }

    const interviewModel: ParticipantInfo = InterviewerDataModel();

    const [remarks, setRemarks] = useState("");
    const onChangeRemarks = (value: any) => {
        setRemarks(value);
    };

    const reactQuillModules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
            //[{ 'header': [1, 2, false] }],
            //[{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
            //['link', 'image'],
            //['clean']
        ],
    }
    const reactQuillFormats = 
        [
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'align',
            // 'header',
            //'list', 'bullet', 'indent',
            //'link', 'image',
        ]
    

    const SaveRemark = (txtId: string): void => {
        dButton = true;
        //let btnCss = document.getElementById("btnSaveRemark") as HTMLButtonElement;
        //btnCss = document.getElementById("btnSaveRemark") as HTMLButtonElement;
        //btnCss.style.backgroundColor = DARK_GREY;

        if (ratingList != undefined) {
            remarkList = [];
            ratingList.map((ratings) => (
                PushRemarkValue(ratings.id)
            ));
        }

        if (remarks != null && remarks != undefined) {
            SaveRemarks(uriCode, remarks, remarkList);
        }
        else {
            //btnCss.style.backgroundColor = 'rgb(12, 68, 172)';
        }

        dButton = false;
    };

    const PushRemarkValue = (id: number): void => {

        const txtValue = document.getElementById(`txtArea_${id}`) as HTMLInputElement;
        if (txtValue != null && txtValue != undefined) {
            remarkList.push({ ratingID: id, remark: txtValue.value })
        }
    };

    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    const [candidateInfo, setCandidateInfo] = useState({ status: 0, btnId: "", bgColor: "", txtLabel: "" });

    const togglePopupClose = () => {
        setIsOpenPopup(!isOpenPopup);
    }

    const toggleAlertClose = () => {
        setIsAlert(!isAlert);
    }

    const CandidateStatusChanged = (status: number, btnId: string, bgColor: string, txtLabel: string): void => {
        if (ValidationOnsubmit() || status == 11) {
            togglePopupClose();
            setCandidateInfo({ status, btnId, bgColor, txtLabel });
        }
        else {
            toggleAlertClose();
        }
    };

    const SaveRemarkConfirm = (): void => {
        if (candidateInfo != null && candidateInfo != undefined) {
            togglePopupClose();
            UpdateCandidateStatus(uriCode, candidateInfo.status);
            UpdateStatus(candidateInfo.status);
            const Ids = ["btnSelect", "btnReject", "btnNoShow"];

            for (let i = 0; i < Ids.length; i++) {
                let element = document.getElementById(Ids[i]) as HTMLButtonElement;
                element = document.getElementById(Ids[i]) as HTMLButtonElement;
                if (Ids[i] == candidateInfo.btnId) {
                    element.style.backgroundColor = candidateInfo.bgColor;
                    element.style.borderColor = candidateInfo.bgColor;
                    element.setAttribute("aria-valuetext", "normal");

                }
                else {
                    element.setAttribute("aria-valuetext", "btnGrey");
                    //element.classList.remove("CandStS");
                    element.style.backgroundColor = DARK_GREY;
                    element.style.borderColor = DARK_GREY;
                }
            }

            SaveRemark("");
        }
    }

    var popupBodyContent = () => {
        return (
            <Typography>
                Are you sure you want to mark this candidate as {candidateInfo.txtLabel} ?
            </Typography>
        );
    }

    var alertBodyContent = () => {
        return (
            <Typography>
                Please fill the mandatory fields.
            </Typography>
        );
    }
    const ValidationOnsubmit = (): boolean => {
        let result = true;
        interviewModel.ratingsList?.forEach(item => {
            if (!CheckNullEmptyUndefined(item.remark)) {
                const txtValue = document.getElementById(`txtArea_${item.id}`) as HTMLInputElement;
                txtValue.style.borderColor = "#ff0000";
                result = false;
            }
            if (isNaN(item.score) || item.score == 0) {
                const txtValue = document.getElementById(`ratingTxtInput_${item.id}`) as HTMLInputElement;
                txtValue.style.borderColor = "#ff0000";
                result = false;
            }
        });

        const regex = /(<([^>]+)>)/ig;
        const hasText = !!remarks.replace(regex, "").trim().length;
        const txtValue = document.getElementById(`feedbackTextArea`) as HTMLInputElement;
        if (!hasText) {
            txtValue.style.border = "1px solid #ff0000";
            result = false;
        }
        else {
            txtValue.style.border = "none";
        }
        return result;
    }

    return (
        <>
            <div style={{
                height: '500px',
                overflowY: 'auto',
                scrollBehavior: 'smooth',
                overflowX: 'hidden'
            }}>
                {App1(modelone.isMobile == 'true' ? true : false, modelone.browserName)}
                <div className="feedbackSection">
                    <label title="FeedBack">Overall Feedback</label>
                    {/*<RichTextEditor*/}
                    {/*    value={remarks}*/}
                    {/*    onChange={onChangeRemarks}*/}
                    {/*    className="txtRatingRichBox"*/}
                    {/*    toolbarConfig={toolbarConfig}*/}
                    {/*    editorClassName="editorRatingRichBox"*/}
                    {/*/>*/}
                    <ReactQuill value={remarks}
                        modules={reactQuillModules}
                        formats={reactQuillFormats}
                        onChange={onChangeRemarks}
                        id="feedbackTextArea"
                    />
                </div>
                <div className="ratingActionSection">
                    <div className="row">
                        <div className="col-md-6">
                            <ActionButton id="btnSelect" aria-valuetext={interviewModel.status != undefined && (interviewModel.status == 17 || interviewModel.status == 2) ? "normal" : "btnGrey"} className={selectLinkButtonStyle} onClick={(event) => CandidateStatusChanged(17, "btnSelect", GREEN, SELECTED)}> {/*17*/}
                                {/*<Icon iconName="Copy" className={copyIconStyle} />*/}
                                {/* <Icon iconName="Like" className={copyIconStyle} />*/}
                                <div style={{ paddingTop: "3px" }}>
                                    {/*  <BsFillHandThumbsUpFill style={{ verticalAlign: '-webkit-baseline-middle' } } />*/}
                                    <span className={RatingButtonStyle}> Selected</span>
                                </div>
                            </ActionButton>
                            <ActionButton id="btnReject" style={{ marginLeft: modelone.isMobile == 'true' ? "10px" : "1rem" }} aria-valuetext={interviewModel.status != undefined && (interviewModel.status == 18 || interviewModel.status == 2) ? "normal" : "btnGrey"} className={rejectButtonStyle} onClick={(event) => CandidateStatusChanged(18, "btnReject", MODERATE_RED, REJECTED)}> {/*18*/}
                                {/*<Icon iconName="Copy" className={copyIconStyle} />*/}
                                {/*{RejectString}*/}
                                {/* <BsFillHandThumbsDownFill style={{ verticalAlign: '-webkit-baseline-middle' }} />*/}
                                <div style={{ paddingTop: "3px" }}>
                                    <span className={RatingButtonStyle}> Rejected</span>
                                </div>
                            </ActionButton>
                            <ActionButton id="btnNoShow" style={{ marginLeft: modelone.isMobile == 'true' ? "10px" : "1rem" }} aria-valuetext={interviewModel.status != undefined && (interviewModel.status == 11 || interviewModel.status == 2) ? "normal" : "btnGrey"} className={noShowButtonStyle} onClick={(event) => CandidateStatusChanged(11, "btnNoShow", YELLOW, NOSHOW)}>
                                {/* <Icon iconName="Copy" className={copyIconStyle} />*/}
                                {/*{NoShowString}*/}
                                <div style={{ paddingTop: "3px" }}>
                                    <span className={RatingButtonStyle}>No Show</span>
                                </div>
                            </ActionButton>
                        </div>
                        <div className="col-md-6">
                            {/*<ActionButton id="btnSaveRemark"*/}
                            {/*    className={copyLinkButtonStyle}*/}
                            {/*    onClick={(event) => SaveRemark("RemarksTxt")}*/}
                            {/*    style={{*/}
                            {/*        float: 'right',*/}
                            {/*        width: modelone.isMobile == 'true' ? '100%' : '30%',*/}
                            {/*        marginTop: modelone.isMobile == 'true' ? '10px' : '0px'*/}
                            {/*    }}*/}
                            {/*    disabled={dButton}                > */}{/*17*/}

                            {/*    <div style={{ paddingTop: "3px" }}>*/}
                            {/*        <span className={RatingButtonStyle}> Save </span>*/}
                            {/*    </div>*/}
                            {/*</ActionButton>*/}
                        </div>
                    </div>
                </div>
            </div>
            {isOpenPopup && (
                <CustomPopup
                    BodyContent={popupBodyContent}
                    btnCancel="Cancel"
                    btnConfirm="Confirm"
                    lblTitle="Confirm feedback"
                    ConfirmHandler={SaveRemarkConfirm}
                    togglePopupClose={togglePopupClose}
                    popupHeight="auto"
                    isShowCloseButton="true"
                />
                //<Dialog open={true} maxWidth="sm" fullWidth>
                //    <DialogTitle>Confirm the action</DialogTitle>
                //    <Box position="absolute" top={0} right={0}>
                //        <IconButton onClick={togglePopupClose}>
                //            <Close />
                //        </IconButton>
                //    </Box>
                //    <DialogContent>
                //        <Typography>
                //            Are you sure you want to mark this candidate as a {candidateInfo.txtLabel} ?
                //        </Typography>
                //    </DialogContent>
                //    <DialogActions>
                //        <Button color="inherit" variant="contained" onClick={togglePopupClose}>
                //            Cancel
                //        </Button>
                //        <Button color="primary" variant="contained" onClick={(event) => SaveRemarkConfirm()}>
                //            Confirm
                //        </Button>
                //    </DialogActions>
                //</Dialog>
            )}

            {isAlert && (
                <CustomPopup
                    BodyContent={alertBodyContent}
                    btnCancel=""
                    btnConfirm=""
                    lblTitle="Alert!"
                    ConfirmHandler={toggleAlertClose}
                    togglePopupClose={toggleAlertClose}
                    popupHeight="auto"
                    isShowCloseButton="true"
                />
            )}
        </>
    );
};
